import { FaqSection } from '@/components/FaqSection/FaqSection';

export default function FaqPage() {
  return <FaqSection onClose={() => window.history.back()} />;
}
